/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { MenuComponent } from '../../../../../../../_metronic/assets/ts/components'
import { ID, KTSVG, QUERIES } from '../../../../../../../_metronic/helpers'
import { useListView } from '../../core/ListViewProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'
import { updateReviewStatus } from '../../core/_requests'
import { LanguageHelp } from '../../../../../../../_metronic/helpers/LanguageHelper'
import { ReviewDeleteModal } from '../../ReviewDeleteModal'

type Props = {
  id: ID,
  status: string,
  isReviewLoading:boolean
}

const ReviewActionsCell: FC<Props> = ({isReviewLoading,id, status }) => {
  const { setItemIdForUpdate } = useListView()
  const { query } = useQueryResponse()
  const queryClient = useQueryClient()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const openEditModal = () => {
    setItemIdForUpdate(id)
  }

  const activateItem = useMutation(() => updateReviewStatus(id, "1", 1), { // TODO: --VD
    onSuccess: () => { queryClient.invalidateQueries([`${QUERIES.REVIEW_LIST}-${query}`]) },
  })
  const deactivateItem = useMutation(() => updateReviewStatus(id, "1", 2), {
    onSuccess: () => { queryClient.invalidateQueries([`${QUERIES.REVIEW_LIST}-${query}`]) },
  })
  const deleteItem = useMutation(() => updateReviewStatus(id, "1", 3), {
    onSuccess: () => { queryClient.invalidateQueries([`${QUERIES.REVIEW_LIST}-${query}`]) },
  })

  return (
    <>
      <ReviewDeleteModal isReviewLoading={isReviewLoading} id={id}/>
      <a
        href='#'
        style={{display:'inline-flex'}}
        className='btn btn-light btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        {LanguageHelp('Actions')}
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' style={{paddingTop: '0.1rem'}} className='svg-icon-5 m-0' />
      </a>
      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        data-kt-menu='true'
      >
        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={openEditModal}>
            {LanguageHelp('Edit')}
          </a>
        </div>
        {/* end::Menu item */}

        {(status === "Passive" || status === "Deleted") &&
          <div>
            {/* begin::Menu item */}
            <div className='menu-item px-3'>
              <a
                className='menu-link px-3'
                data-kt-review-table-filter='activate_row'
                onClick={async () => await activateItem.mutateAsync()}
              >
                {LanguageHelp('Activate')}
              </a>
            </div>
            {/* end::Menu item */}
          </div>
        }

        {status === "Active" &&
          <div>
            {/* begin::Menu item */}
            <div className='menu-item px-3'>
              <a
                className='menu-link px-3'
                data-kt-review-table-filter='deactivate_row'
                onClick={async () => await deactivateItem.mutateAsync()}
              >
                {LanguageHelp('Deactivate')}
              </a>
            </div>
            {/* end::Menu item */}
          </div>
        }

        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <a
            href='#'
            className='menu-link px-3'
            data-bs-toggle='modal' data-bs-target={'#kt_modal_reviewDelete'+id}
          >
            {LanguageHelp('Delete')}
          </a>
        </div>
        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
    </>
  )
}

export { ReviewActionsCell }
